"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var TileLoader_1 = require("../TileLoader");
/**
 * IntervalTileLoader makes it possible to transform a query result into tiles containing intervals
 *
 * It has two tile levels, micro and macro
 *
 * Micro tiles have lod 0 and are used to store intervals with base-pair precision
 *
 * Macro tile have lod level `this.macroLodLevel` and store many more intervals but with lower precision (not enough to display with base-pair precision)
 */
var IntervalTileLoader = /** @class */ (function (_super) {
    __extends(IntervalTileLoader, _super);
    function IntervalTileLoader(dataSource, model, contig, tileSize) {
        if (tileSize === void 0) { tileSize = 1 << 15; }
        var _this = _super.call(this, tileSize, // tile size
        1) || this;
        _this.dataSource = dataSource;
        _this.model = model;
        _this.contig = contig;
        _this.microLodThreshold = 3;
        _this.macroLodLevel = 10;
        return _this;
    }
    IntervalTileLoader.cacheKey = function (model) {
        return null;
    };
    IntervalTileLoader.getAvailableContigs = function (model) {
        var contigs = new Array();
        return Promise.resolve(contigs);
    };
    IntervalTileLoader.prototype.mapLodLevel = function (l) {
        if (l <= this.microLodThreshold) {
            return 0;
        }
        else {
            return this.macroLodLevel;
        }
    };
    IntervalTileLoader.prototype.getTilePayload = function (tile) {
        console.warn('Loading intervals from static files is not yet supported');
        return { intervals: new Float32Array(0) };
    };
    return IntervalTileLoader;
}(TileLoader_1.TileLoader));
exports.IntervalTileLoader = IntervalTileLoader;
exports.default = IntervalTileLoader;
